import { render, staticRenderFns } from "./DynamicsListPage.vue?vue&type=template&id=00f815b5&scoped=true&"
import script from "./DynamicsListPage.vue?vue&type=script&lang=js&"
export * from "./DynamicsListPage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicsListPage.vue?vue&type=style&index=0&id=00f815b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f815b5",
  null
  
)

export default component.exports